module.exports = __webpack_public_path__ + "5ee07141ea9ccd4c5c35273be29eb9b4.svg";